import styled, { css } from 'styled-components';
import { FlexColumnCenter, smallBody } from '@ubeya/shared-web/components';

const DayButton = styled(FlexColumnCenter)`
  ${smallBody};
  text-transform: none;
  width: ${({ allWeek }) => (allWeek ? '100px' : '42px')};
  height: 40px;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ theme, isSelected, inverted }) =>
    isSelected && !inverted ? theme.colors.primary : theme.colors.white};
  color: ${({ theme, isSelected, inverted }) =>
    isSelected ? (inverted ? theme.colors.primary : theme.colors.white) : theme.colors.grey4};
  border: 1px solid
    ${({ theme, isSelected, inverted }) =>
      isSelected ? (inverted ? theme.colors.primary : theme.colors.disabled) : theme.colors.grey2};
  box-shadow: none;
  text-transform: uppercase;
  transition: 200ms;

  ${({ isSelected }) =>
    !isSelected &&
    css`
      &:hover {
        border-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.grey4};
      }
    `}

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export default DayButton;
